export default "__VITE_ASSET__DyRxaNe4__"